"use client"

import React, { useState } from 'react';
import Link from 'next/link';

const ShutdownBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="top-0 z-50 w-full bg-orange-50 dark:bg-white/[0.03] border-b border-orange-500/20 dark:border-orange-500/15 shadow-[0_1px_15px_-3px_rgba(249,115,22,0.3)] dark:shadow-[0_1px_15px_-3px_rgba(249,115,22,0.15)]">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-500/[0.08] dark:via-orange-500/[0.07] to-transparent pointer-events-none" />
      <div className="relative flex items-center justify-center gap-x-3 px-4 py-2.5 text-sm">
        <span className="text-neutral-600 dark:text-neutral-400 text-xs sm:text-sm">
          Saved is sunsetting operations as of March 2026.
        </span>
        <Link
          href="/sunset"
          className="text-xs sm:text-sm font-medium text-orange-700 dark:text-neutral-200 underline underline-offset-2 decoration-orange-400 hover:decoration-orange-600 dark:decoration-neutral-500 dark:hover:decoration-neutral-300 transition-colors flex-shrink-0"
        >
          Read more
        </Link>
        {/* <button
          className="ml-1 p-0.5 rounded text-neutral-500 hover:text-neutral-300 transition-colors flex-shrink-0"
          aria-label="Dismiss"
          onClick={() => setIsVisible(false)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button> */}
      </div>
    </div>
  );
};

export default ShutdownBanner;
